module.exports = __webpack_public_path__ + "static/media/llamadaVideoLlamada_VideoLlamada.0de6159c.svg";